import EmptyHistory from './EmptyHistory';

export default EmptyHistory;